import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "../../../../shared/components/Modal/Modal";
import "./TestSyllabusModal.css";
import images from "../../../../utilities/images/images";
import { clearAitsSyllabus } from "../../../../redux/aits/aitsSlice";

const TestSyllabusModal = ({ onClose }) => {
  const dispatch = useDispatch();

  const { syllabusData, syllabusLoading } = useSelector(
    (state) => state.aitsTests
  );

  const handleClose = () => {
    dispatch(clearAitsSyllabus());
    onClose();
  };

  if (syllabusLoading) {
    return (
      <Modal isOpen={true} onClose={handleClose} width="440px" >
        <div className="syllabus_modal_content">Loading syllabus…</div>
      </Modal>
    );
  }

  if (!syllabusData) return null;

  const { syllabus = [], coverage_summary, paper } = syllabusData;

  return (
    <Modal isOpen={true} onClose={handleClose} width="400px" height="27.5rem" >
  <div className="syllabus_modal_content">

    <div className="syllabus_header sticky_header">
      <h2>Test Syllabus</h2>
      <p>{paper?.test_name}</p>
    </div>

    <div className="syllabus_scroll_area">
      {syllabus.map((item, index) => (
        <div className="syllabus_subject_container" key={index}>
          <div className="syllabus_subject_header">
            <div className="syllabus_subject_left">
              <img
                src={item.icon || images.physics_icon}
                className="syllabus_subject_icon"
                alt={item.subject}
              />
              <span className="syllabus_subject_name">
                {item.subject}
              </span>
            </div>

            <div className="syllabus_topic_count">
              {item.topics?.length || 0} topics
            </div>
          </div>

          <ul className="syllabus_topic_list">
            {item.topics?.map((topic, i) => (
              <li key={i}>{topic}</li>
            ))}
          </ul>
        </div>
      ))}

      <div className="coverage_summary_content">
        <div className="coverage_summary_header">Coverage Summary</div>
        <div className="coverage_summary">
          <div>
            Total Subjects: <strong>{coverage_summary?.total_subjects}</strong>
          </div>
          <div>
            Total Topics: <strong>{coverage_summary?.total_topics}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</Modal>

  );
};

export default TestSyllabusModal;
